export { useGetAccountLink } from './useGetAccountLink';
